import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  dogs: [],
  activeDog: null,
};

const dogSlice = createSlice({
  name: "dogs",
  initialState,
  reducers: {
    setDogs: (state, action) => {
      state.dogs = action.payload;
    },
    setActiveDog: (state, action) => {
      state.activeDog = action.payload;
    },
  },
});

export const { setDogs, setActiveDog } = dogSlice.actions;
export default dogSlice.reducer;
